import AuthenticationService from "service/auth/AuthenticationService";
import EnvironmentService from "service/environment/EnvironmentService";
import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

let environmentService = new EnvironmentService();
let serviceAPI = environmentService.getServiceAPI();
let header = {
  Authorization: "api-labtest-request-service",
  client: "service",
};
class NavigoAPIServices {
  constructor() {
    this.authenticationService = new AuthenticationService();
    this.environmentService = new EnvironmentService();
    this.apiService = new APIService();
  }
  //create appointment
  createAppointment = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.createAppointment;
    this.apiService.post(url, body, onResponse, onError);
  };

  uploadDocumentDigital(body, onResponse, onError) {
    let url = APIConfig.navigoDashboard.uploadDocumentDigital;
    return this.apiService.post(url, body, onResponse, onError);
  }
  uploadDocumentLabtestAutomation(body, onResponse, onError) {
    let url = APIConfig.navigoDashboard.uploadDocumentLabtestAutomation;
    return this.apiService.post(url, body, onResponse, onError);
  }
  //get patient data
  getPatientData = (searchStr, onResponse, onError) => {
    let url = APIConfig.patient.search.format(searchStr, 2, true);
    this.apiService.get(url, onResponse, onError);
  };
  //get data through patient ID
  getPatientDataThroughID = (searchStr, onResponse, onError) => {
    let url = APIConfig.patient.get.format(searchStr);
    this.apiService.get(url, onResponse, onError);
  };
  //get appointment by patient
  getAppointMentByPatient = (id, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.appointmentByPatient.format(id);
    this.apiService.get(url, onResponse, onError);
  };
  //get all appointments
  getAllAppointments = (
    limit,
    skip,
    onResponse,
    onError,
    status,

    filter = "",
    fromDate = "",
    toDate = "",
    serviceType = "",
    createdFrom = "",
    createdTo = ""
  ) => {
    let url = APIConfig.navigoDashboard.allAppointments.format(
      limit,
      skip,
      filter,
      fromDate,
      toDate,
      serviceType,
      createdFrom,
      createdTo
    );
    if (status !== 4) {
      url = APIConfig.navigoDashboard.getAllAppointmentByStatus.format(
        status,
        limit,
        skip,
        filter,
        fromDate,
        toDate,
        serviceType
      );
    }
    this.apiService.get(url, onResponse, onError);
  };
  //update appointment
  updateAppointment = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.createAppointment;
    this.apiService.put(url, body, onResponse, onError);
  };
  //get time slots
  getTimeSlots = (serviceId, email, date, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.getTimeSlots.format(
      serviceId,
      date,
      email
    );
    this.apiService.get(url, onResponse, onError);
  };
  //get All services
  getAllServices = (onResponse, onError) => {
    let url = APIConfig.navigoDashboard.getAllServices;
    this.apiService.get(url, onResponse, onError);
  };
  //get single service data
  getSingleServiceData = (id, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.getAllServices + "/" + `${id}`;
    this.apiService.get(url, onResponse, onError);
  };

  //get service by client code
  getServiceByClientCode = (clientCode, onResponse, onError) => {
    let url =
      APIConfig.navigoDashboard.getServiceByClientCode.format(clientCode);
    this.apiService.get(url, onResponse, onError);
  };

  //get service by patient id
  getServiceByPatientId = (patientId, onResponse, onError) => {
    let url =
      APIConfig.navigoDashboard.getServicesByPatientId.format(patientId);
    this.apiService.get(url, onResponse, onError);
  };

  //create a service
  createService = (isCustom, cc, id, body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.createService;
    let customBody = { ...body };
    if (isCustom) {
      url = APIConfig.navigoDashboard.createUpdateCustomizedService;
      customBody = { ...body, masterService: id, clientCode: cc };
    }

    this.apiService.post(url, customBody, onResponse, onError);
  };

  //update service
  updateService = (isCustom, cc, body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.createService;
    let customBody = { ...body };
    if (isCustom) {
      url = APIConfig.navigoDashboard.createUpdateCustomizedService;
      customBody = { ...body, masterService: body.ID, clientCode: cc };
    }
    this.apiService.put(url, body, onResponse, onError);
  };

  //get All client code
  getAllClientCode = (onResponse, onError) => {
    let url = APIConfig.whitelisting.getAll;
    this.apiService.get(url, onResponse, onError);
  };

  //get All calendars
  getAllCalendars = (onResponse, onError) => {
    let url = APIConfig.navigoDashboard.getAllCalendars;
    this.apiService.get(url, onResponse, onError);
  };

  //
  getCalendarAccessLink = () => {
    return APIConfig.navigoDashboard.accessCalendars;
  };

  //update stataus of appointment
  updateAppointmentStatus = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.updateAppointmentStatus;
    return this.apiService.post(url, body, onResponse, onError);
  };

  //reschedule appointments
  rescheduleAppointments = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.rescheduleAppointments;
    return this.apiService.post(url, body, onResponse, onError);
  };

  //upload  image
  uploadImg = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.uploadContent;
    return this.apiService.postWithFormData(url, body, onResponse, onError);
  };

  //upload patient report
  uploadDocument(fileUrl, fileName, document, onSuccess, onError, pId = null) {
    let documentRequest = new FormData();
    let documentJSON = {};
    // documentJSON.id = document.id;
    documentJSON.patientId = pId;

    documentJSON.title = fileName;
    documentJSON.description = document.description;
    documentJSON.type = document.type;
    documentJSON.format = document.format;
    documentJSON.status = document.status;

    documentRequest.append("file", fileUrl);
    documentRequest.append("fileName", fileName);
    documentRequest.append("document", JSON.stringify(documentJSON));
    documentRequest.append("patientId", pId);

    const url = APIConfig.documentApis.uploadDoc;
    this.apiService.postWithFormData(
      url,
      documentRequest,

      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      }
    );
  }

  //get user's address
  getPrimaryAddress = (id, onResponse, onError) => {
    let url = APIConfig.familyPlan.primaryAddress.format(id);
    return this.apiService.get(url, onResponse, onError);
  };

  //get time slots for redcliffe and thyrocare
  getLabtestTimeSlot = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.getTimeSlotForLabTest;
    return this.apiService.post(url, body, onResponse, onError);
  };
  //create labtest appointment
  createLabtestAppointment = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.bookingForLabtest;
    return this.apiService.post(url, body, onResponse, onError);
  };
  // cancel and reschedule lab appointments
  cancelAndRescheduleLabAppointments = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.bookingForLabtest;
    return this.apiService.put(url, body, onResponse, onError);
  };

  //get customised services
  getCustomizedServices = (id, cc, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.getCustomizedService.format(id, cc);
    return this.apiService.get(url, onResponse, onError);
  };
  //upload appointment csv
  uploadAppointCSV = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.uploadAppointCSV;
    return this.apiService.postWithFormDataDownload(
      url,
      body,
      onResponse,
      onError
    );
  };
  //get all vendors
  getAllVendors = (onResponse, onError) => {
    let url = APIConfig.navigoDashboard.vendors.all;
    return this.apiService.get(url, onResponse, onError);
  };

  //get all packages
  getAllPackages = (onResponse, onError) => {
    let url = APIConfig.navigoDashboard.packages.all;
    return this.apiService.get(url, onResponse, onError);
  };

  //get vendor packages
  getAllPackagesVendor = (id, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.vendors.packageVendor + "/" + id;
    return this.apiService.get(url, onResponse, onError);
  };

  //update appointment package id
  updatePackageId = (data, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.updatePackage;
    return this.apiService.post(url, data, onResponse, onError);
  };

  getDocumentByAppointment = (id, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.getDocumentByAppointment.format(id);
    return this.apiService.get(url, onResponse, onError);
  };

  getAllClaims = (
    size,
    maxid,
    onResponse,
    onError,
    filters = "",
    createdFrom,
    createdTo
  ) => {
    let url = APIConfig.navigoDashboard.getallClaims.format(
      size,
      maxid,
      filters,
      createdFrom,
      createdTo
    );
    return this.apiService.get(url, onResponse, onError);
  };

  getAllClaimTypes = (planId, pid, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.getAllClaimTypes.format(planId, pid);
    return this.apiService.get(url, onResponse, onError);
  };

  getClaimTypeLimit = (pid, planId, typeId, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.getClaimTypeLimit.format(
      pid,
      planId,
      typeId
    );
    return this.apiService.get(url, onResponse, onError);
  };

  updateClaim = (id, payload, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.updateClaim.format(id);
    return this.apiService.put(url, payload, onResponse, onError);
  };

  updateClaimType = (id, payload, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.updateClaim.format(id);
    return this.apiService.put(url, payload, onResponse, onError);
  };

  createReimbursementClaim = (payload, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.createReimbursementClaim;
    return this.apiService.post(url, payload, onResponse, onError);
  };

  // Save an in-progress claim as a draft (File new claim screen).
  saveClaimDraft = (payload, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.saveClaimDraft;
    return this.apiService.post(url, payload, onResponse, onError);
  };

  // Discard a DRAFT claim (called after a draft is submitted as a real claim).
  deleteClaimDraft = (claimId, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.deleteClaimDraft.format(claimId);
    return this.apiService.delete(url, onResponse, onError);
  };

  // Load a claim by (patientId, claimId) — used to resume a draft into the screen.
  getReimbursementClaimById = (patientId, claimId, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.getReimbursementClaimById.format(
      patientId,
      claimId,
    );
    return this.apiService.get(url, onResponse, onError);
  };

  rejectReason = (onResponse, onError) => {
    let url = APIConfig.navigoDashboard.rejectReason;
    return this.apiService.get(url, onResponse, onError);
  };

  getTransaction = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.getTransaction;
    return this.apiService.post(url, body, onResponse, onError);
  };
  fetchCurrAvailableClaimAmt = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.fetchCurrAvailableClaimAmt;
    return this.apiService.post(url, body, onResponse, onError);
  };

  uploadClaimDocument(
    fileUrl,
    fileName,
    document,
    onSuccess,
    onError,
    pId = null
  ) {
    let documentRequest = new FormData();
    let documentJSON = {};
    documentJSON.patientId = pId;

    documentJSON.title = fileName;
    documentJSON.description = document.description;
    documentJSON.type = document.type;
    documentJSON.format = document.format;
    documentJSON.status = document.status;

    documentRequest.append("file", fileUrl);
    documentRequest.append("fileName", fileName);
    documentRequest.append("document", JSON.stringify(documentJSON));
    documentRequest.append("patientId", pId);

    const url = APIConfig.documentApis.uploadDoc;
    this.apiService.postWithFormData(
      url,
      documentRequest,

      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      }
    );
  }

  getAuto(text, onResponse, onError) {
    let url = APIConfig.navigoDashboard.getIcd.format(text);
    return this.apiService.get(url, onResponse, onError);
  }

  getDocuments(id, onResponse, onError) {
    let url = APIConfig.navigoDashboard.getDocuments.format(id);
    return this.apiService.get(url, onResponse, onError);
  }

  getPlansForPid2(pid, onResponse, onError) {
    let url = APIConfig.myPlan.assigned.getPlansForPid2.format(pid);
    return this.apiService.get(url, onResponse, onError);
  }
  getPlansForPidWithStatus(pid, status, onResponse, onError) {
    let url = APIConfig.myPlan.assigned.getPlansForPidWithStatus.format(
      pid,
      status
    );
    return this.apiService.get(url, onResponse, onError);
  }

  // Fetch the persisted AI adjudication record for a claim (drives the AI
  // claim-details screen).
  getClaimAssessment = (claimId, patientId, onResponse, onError) => {
    let url = APIConfig.claimProcessing.getAssessment.format(claimId);
    // patientId lets the backend build a "claim details only" shell from the wallet
    // claim when there is no AI record yet (instead of 404ing the whole screen).
    if (patientId) url += "?patientId=" + patientId;
    return this.apiService.get(url, onResponse, onError);
  };

  // Submit the evaluator's review of the AI suggestion (Correct/Incorrect +
  // reason + per-rule/per-line judgments).
  submitClaimEvaluation = (claimId, payload, onResponse, onError) => {
    let url = APIConfig.claimProcessing.submitEvaluation.format(claimId);
    return this.apiService.put(url, payload, onResponse, onError);
  };

  // Record an ops correction to the prescription capture. The payload carries the
  // COMPLETE set ({ prescriptionDetails, editedBy }) — an omitted field is stored
  // as empty, which is how a value the AI wrongly extracted gets cleared.
  updateClaimPrescriptionDetails = (claimId, payload, onResponse, onError) => {
    const url = APIConfig.claimProcessing.updatePrescriptionDetails.format(claimId);
    return this.apiService.put(url, payload, onResponse, onError);
  };

  // ICD-10 candidates for the prescription-details editor. Ops picks from the
  // master rather than typing a code, so what gets stored is a real ICD row.
  searchIcd = (queryString, onResponse, onError) => {
    const url = APIConfig.claimProcessing.searchIcd.format(
      encodeURIComponent(queryString || ""),
      50
    );
    return this.apiService.get(url, onResponse, onError);
  };

  // Coverage-rules catalog (inclusions/exclusions/required docs) for a category.
  getClaimRules = (category, onResponse, onError) => {
    let url = APIConfig.claimProcessing.getRules.format(category);
    return this.apiService.get(url, onResponse, onError);
  };

  // Client/account configs (each has accountCode + accountName) — used to
  // resolve an account code to its display name on the claim-details screen.
  getAccountConfigs = (onResponse, onError) => {
    return this.apiService.get(APIConfig.whitelisting.getAll, onResponse, onError);
  };

  // --- Reimbursement AI dashboard ---
  // List (wallet merges AI summary into each claim).
  fetchClaimAIDashboard = (body, onResponse, onError) => {
    return this.apiService.post(
      APIConfig.claimProcessing.dashboardList,
      body,
      onResponse,
      onError
    );
  };
  // KPI stats (from the claim/AI service).
  fetchClaimDashboardStats = (body, onResponse, onError) => {
    return this.apiService.post(
      APIConfig.claimProcessing.dashboardStats,
      body,
      onResponse,
      onError
    );
  };
  // Filter dropdown options for evaluator/accountCode/planId/category.
  fetchDashboardClaimTypes = (onResponse, onError) => {
    return this.apiService.get(
      APIConfig.claimProcessing.dashboardClaimTypes,
      onResponse,
      onError
    );
  };
  fetchClaimFilterOptions = (field, q, offset, limit, onResponse, onError) => {
    const url = APIConfig.claimProcessing.filterOptions.format(
      field,
      q || "",
      offset || 0,
      limit || 50
    );
    return this.apiService.get(url, onResponse, onError);
  };
  // Assign an evaluator (Pending -> Under review) for the Evaluate button.
  assignClaimEvaluator = (claimId, body, onResponse, onError) => {
    const url = APIConfig.claimProcessing.assignEvaluator.format(claimId);
    return this.apiService.put(url, body, onResponse, onError);
  };
}

export default NavigoAPIServices;
